import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Skeleton } from "@progress/kendo-react-indicators";
import React from "react";
import KvkkService from "../../services/KvkkService";
import { PDFViewer } from "@progress/kendo-react-pdf-viewer";

const NotApprovedWarning = ({ onClose, open }) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState();
  React.useEffect(() => {
    setLoading(true);
    KvkkService.getLastOne("DAIKIN_ONAYLANMADI_UYARI")
      .then((result) => setData(result.data[0]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Dialog open={open} onClose={onClose} maxWidth={"md"}>
      <DialogTitle>{data?.basliK_TR}</DialogTitle>
      <DialogContent>
        <div
          style={{
            padding: "20px",
            backgroundColor: "#f9f9f9",
            border: "1px solid #e0e0e0",
            borderRadius: "4px",
            lineHeight: "1.6",
            fontSize: "14px",
          }}
        >
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {loading && (
              <Skeleton shape="rectangle" style={{ width: "100%" }} />
            )}
            {data?.iceriK_TR && data.dokumaN_TIPI === "PDF" && (
              <PDFViewer
                data={data?.iceriK_TR}
                style={{
                  height: 615,
                }}
              />
            )}
            {data?.iceriK_TR && data.dokumaN_TIPI === "TEXT" && data?.iceriK_TR}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NotApprovedWarning;
